<template lang="pug">
  .dashboard
    .box.mt-4
      b-tabs
        b-tab(title="Annetused")
          DonationsHeatmap
        b-tab(title="UTM kampaaniad")
          UTM
</template>

<script>
import UTM from './UTM'
import DonationsHeatmap from './DonationsHeatmap'

export default {
  components: { UTM, DonationsHeatmap }
}
</script>

<style lang="scss">
</style>
